import React, { useState, useEffect } from "react";
import { Modal, Button, InputGroup, FormControl, ListGroup, Tooltip, OverlayTrigger } from "react-bootstrap";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaWhatsapp, FaEnvelope, FaUsers, FaSms } from "react-icons/fa";
import EmailInputBox from "./EmailInputTextBox";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import LinearProgress from "@mui/material/LinearProgress";

// // Sample members list
// const members = [
//   { id: 1, name: "Alice" },
//   { id: 2, name: "Bob" },
//   { id: 3, name: "Charlie" },
//   { id: 4, name: "David" },
//   { id: 5, name: "Eva" },
//   { id: 6, name: "Frank" },
//   { id: 7, name: "Grace" },
//   { id: 8, name: "Hannah" },
//   { id: 9, name: "Ian" },
//   { id: 10, name: "Jane" },
//   { id: 11, name: "Kyle" },
//   { id: 12, name: "Laura" },
// ];

const ShareModal = ({ show, handleClose }) => {
    const [emailInput, setEmailInput] = useState("");
    const [emailList, setEmailList] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const [statusClass, setStatusClass] = useState("");
    const [copyStatus, setCopyStatus] = useState("Copy");
    const [showMemberSelection, setShowMemberSelection] = useState(false);
    const [showEmailBox, setShowEmailBox] = useState(false);
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [members, setMembers] = useState([]);
    const [link, setLink] = useState(window.location.href);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [showSmsBox, setShowSmsBox] = useState(false);
    const [smsNumber, setSmsNumber] = useState("");

    const user_key = sessionStorage.getItem("pk_user_key");

    const reverseString = (str) => {
        if (!str) return "";
        return str.split("").reverse().join("");
    };
    const reversedKey = reverseString(user_key);
    // const referralcode = btoa(reversedKey);
    const referralcode = reversedKey;
    const encReferralCode = btoa(reversedKey);

    useEffect(() => {
        if (user_key) {
            setLink(window.location.href + "?key=" + btoa(user_key));
        }
    }, [user_key]);

    const copyToClipboard = async () => {
        try {
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(link);
                setCopyStatus("Copied");
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = link;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
                setCopyStatus("Copied");
            }
            setTimeout(() => setCopyStatus("Copy"), 2000);
        } catch (error) {
            console.error("Failed to copy text:", error);
            setCopyStatus("Failed");
        }
    };

    useEffect(() => {
        fetchAllUser();
    }, []);

    const fetchAllUser = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllMemberData",
            created_by: sessionStorage.getItem("pk_user_key"),
        });

        const output = response.data;

        if (output.length > 0) {
            setMembers(output);
        }
    };
    console.log("users", members);

    const handleEmailInputChange = (e) => {
        setEmailInput(e.target.value);
    };

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleInputKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            addEmail(inputValue);
        }
    };

    const addEmail = (email) => {
        const trimmedEmail = email.trim();
        if (trimmedEmail && !emailList.includes(trimmedEmail)) {
            setEmailList([...emailList, trimmedEmail]);
            setInputValue("");
        }
    };

    const handleRemoveEmail = (email) => {
        setEmailList(emailList.filter((e) => e !== email));
    };

    // const handleSendEmail = () => {
    //   if (emailList.length > 0) {
    //     setStatusMessage("Emails sent successfully");
    //     setStatusClass("bg-success text-light");

    //     setTimeout(() => {
    //       setStatusMessage("");
    //       setStatusClass("");
    //       setEmailList([]);
    //     }, 3000);
    //   } else {
    //     setShowEmailBox(false);
    //   }
    // };

    const handleSendEmail = async () => {
        if (emailInput && link) {
            setIsSubmitting(true);
            // Ensure both fields are filled
            try {
                const response = await axios.post(`${BASE_URL}API/apicall`, {
                    email: emailInput, // Add emailInput to the payload
                    ac_link: link, // Current page link
                    security_key: security_key,
                    mode: "sendArticleLinkEmail",
                    created_by: sessionStorage.getItem("pk_user_key"),
                    // referral_code: encodeURIComponent(referralcode),
                    referral_code: referralcode,
                });

                if (response.data === 1) {
                    setStatusMessage("Email sent successfully");
                    setStatusClass("bg-success text-light");
                    setEmailInput("");
                    toast.success("Email sent successfully!", {
                        autoClose: 3000,
                    });
                } else {
                    toast.error("Failed to send email.", {
                        autoClose: 3000,
                    });
                    setStatusMessage("Failed to send email");
                    setStatusClass("bg-danger text-light");
                }

                setTimeout(() => {
                    setStatusMessage("");
                    setStatusClass("");
                }, 3000);
            } catch (error) {
                console.error("Error sending email:", error);
                setStatusMessage("Error occurred while sending email");
                setStatusClass("bg-danger text-light");
            } finally {
                setIsSubmitting(false);
            }
        } else {
            setStatusMessage("Please provide an email address");
            setStatusClass("bg-danger text-light");
        }
    };

    const handleEmailClick = () => {
        setShowEmailBox(true);
    };

    const handleBackClick = () => {
        setShowEmailBox(false);
        setShowMemberSelection(false);
    };

    const handleSelectMember = (memberKey) => {
        setSelectedMembers((prevSelected) =>
            prevSelected.includes(memberKey) ? prevSelected.filter((key) => key !== memberKey) : [...prevSelected, memberKey]
        );
    };

    const handleSend = async () => {
        if (selectedMembers.length === 0) {
            setStatusMessage("No members selected.");
            setStatusClass("bg-danger text-light");
            return;
        }

        try {
            const promises = selectedMembers.map((memberKey) => {
                const member = members.find((member) => member.pk_user_key === memberKey);
                return axios.post(`${BASE_URL}API/apicall`, {
                    user_key: member.pk_user_key,
                    ac_link: link,
                    security_key: security_key,
                    mode: "shareAcNotification",
                    created_by: sessionStorage.getItem("pk_user_key"),
                });
            });

            // Wait for all requests to complete
            const responses = await Promise.all(promises);

            // Check responses to see if all notifications were sent successfully
            const allSuccess = responses.every((response) => response.data === 1);

            if (allSuccess) {
                toast.success("Article shared successfully to selected members.", {
                    autoClose: 3000,
                });
                setStatusMessage("Notifications sent successfully to selected members.");
                setStatusClass("bg-success text-light");
            } else {
                toast.error("Failed to share article.", {
                    autoClose: 3000,
                });
                setStatusMessage("Some notifications failed to send.");
                setStatusClass("bg-danger text-light");
            }
        } catch (error) {
            console.error("Error sending notifications:", error);
            setStatusMessage("Error occurred while sending notifications.");
            setStatusClass("bg-danger text-light");
        }

        // Reset selected members and hide selection
        setSelectedMembers([]);
        setShowMemberSelection(false);

        // Reset status message after a few seconds
        setTimeout(() => {
            setStatusMessage("");
            setStatusClass("");
        }, 3000);
    };

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            {selectedMembers.length === 0
                ? "Select members to share"
                : selectedMembers.map((key) => members.find((member) => member.pk_user_key === key)?.user_name).join(", ")}
        </Tooltip>
    );

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const handleShareAllTopline = async () => {
        const toplineMembers = members.filter((member) => Number(member.user_level) === 7);

        if (toplineMembers.length === 0) {
            toast.info("No topline members found.", { autoClose: 3000 });
            setShowConfirmModal(false);
            return;
        }

        try {
            setIsSubmitting(true);

            const promises = toplineMembers.map((member) =>
                axios.post(`${BASE_URL}API/apicall`, {
                    user_key: member.pk_user_key,
                    ac_link: link,
                    security_key: security_key,
                    mode: "shareAcNotification",
                    created_by: sessionStorage.getItem("pk_user_key"),
                })
            );

            const responses = await Promise.all(promises);
            const allSuccess = responses.every((res) => res.data === 1);

            if (allSuccess) {
                toast.success("Article shared successfully to all topline members.", { autoClose: 3000 });
                setStatusMessage("Shared successfully with all topline members.");
                setStatusClass("bg-success text-light");
            } else {
                toast.error("Some notifications failed to send.", { autoClose: 3000 });
                setStatusMessage("Some topline notifications failed to send.");
                setStatusClass("bg-danger text-light");
            }
        } catch (error) {
            console.error("Error sharing with topline members:", error);
            toast.error("Error occurred while sharing with topline members.", { autoClose: 3000 });
            setStatusMessage("Error occurred while sharing with topline members.");
            setStatusClass("bg-danger text-light");
        } finally {
            setIsSubmitting(false);
            setShowConfirmModal(false); // close modal
            setTimeout(() => {
                setStatusMessage("");
                setStatusClass("");
            }, 3000);
        }
    };

    const handleSendSms = async () => {
        if (!smsNumber || !link) {
            toast.error("Please enter a phone number!", { autoClose: 3000 });
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await axios.post(`${BASE_URL}API/send_sms.php`, {
                security_key: security_key,
                mode: "sendSMSLink",
                phone: smsNumber,
                ac_link: link,
                referral_code: referralcode,
                created_by: sessionStorage.getItem("pk_user_key"),

            });

            if (response.data.status === "success") {
                toast.success("SMS sent successfully!", { autoClose: 3000 });
                setSmsNumber("");
                setShowSmsBox(false);
            } else {
                toast.error("Failed to send SMS.", { autoClose: 3000 });
                console.error(response.data.message);
            }
        } catch (error) {
            console.error("Error sending SMS:", error);
            toast.error("Error occurred while sending SMS.", { autoClose: 3000 });
        } finally {
            setIsSubmitting(false);
        }
    };




    return (
        <>
            <ToastContainer position="top-center" />
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>{/* <Modal.Title>Share This Article</Modal.Title> */}</Modal.Header>
                <Modal.Body className="text-center">
                    <h3 className="fw-bold">Share News, Earn Rewards!</h3>
                    <p>Love our articles? Share with your network and earn rewards! Join our referral program today and start benefiting from every share!</p>
                    {showEmailBox ? (
                        <div>
                            <InputGroup className="mb-3">
                                <FormControl
                                    type="email"
                                    value={emailInput}
                                    onChange={handleEmailInputChange} // Bind input change
                                    placeholder="Enter email address"
                                />
                            </InputGroup>
                            {/* {statusMessage && (
                            <div className={`alert ${statusClass} mb-3`} role="alert">
                                {statusMessage}
                            </div>
                        )} */}
                            <div className="act-email-btn mt-3">
                                <Button variant="dark" onClick={handleSendEmail} disabled={isSubmitting}>
                                    Send
                                    {isSubmitting && <LinearProgress />}
                                </Button>
                                <Button variant="outline-secondary" onClick={handleBackClick} className="ms-2">
                                    Back
                                </Button>
                            </div>
                        </div>
                    ) : showSmsBox ? (
                        /* ===== SMS BOX ===== */
                        <div>
                            <InputGroup className="mb-3">
                                <FormControl
                                    type="tel"
                                    placeholder="Enter US phone number (+1...)"
                                    value={smsNumber}
                                    onChange={(e) => setSmsNumber(e.target.value)}
                                />
                            </InputGroup>

                            <div className="act-sms-btn mt-3">
                                <Button
                                    variant="dark"
                                    onClick={handleSendSms}
                                    disabled={isSubmitting}
                                >
                                    Send SMS
                                    {isSubmitting && <LinearProgress />}
                                </Button>
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => setShowSmsBox(false)}
                                    className="ms-2"
                                >
                                    Back
                                </Button>
                            </div>
                        </div>
                    ) : !showMemberSelection ? (
                        <>
                            <InputGroup className="mb-3">
                                <FormControl type="text" value={link} readOnly className="form-control" />
                                <Button variant="outline-secondary" onClick={copyToClipboard}>
                                    {copyStatus}
                                </Button>
                            </InputGroup>

                            <div className="share-options mt-3">
                                <p>Share on:</p>
                                <div className="d-flex justify-content-center">
                                    {/* <Button
                                    variant="link"
                                    className="p-2 rounded-circle bg-light mx-1 text-dark"
                                    onClick={() =>
                                        window.open(
                                            `https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                                                link + "if you're new here sign-up with the referral code : " + encodeURIComponent(referralcode)
                                            )}`,
                                            "_blank"
                                        )
                                    }
                                >
                                    <FaFacebookF size={24} />
                                </Button> */}
                                    <Button
                                        variant="link"
                                        className="p-2 rounded-circle bg-light mx-1 text-dark"
                                        onClick={() => {
                                            const shareUrl = `https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}&quote=${encodeURIComponent(
                                                "if you're new here sign-up with the referral code: " + referralcode
                                            )}`;
                                            window.open(shareUrl, "_blank");
                                        }}
                                    >
                                        <FaFacebookF size={24} />
                                    </Button>

                                    <Button
                                        variant="link"
                                        className="p-2 rounded-circle bg-light mx-1 text-dark"
                                        onClick={() =>
                                            window.open(
                                                `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                                                    link + "if you're new here sign-up with the referral code : " + referralcode
                                                )}`,
                                                "_blank"
                                            )
                                        }
                                    >
                                        <FaTwitter size={24} />
                                    </Button>
                                    <Button
                                        variant="link"
                                        className="p-2 rounded-circle bg-light mx-1 text-dark"
                                        onClick={() =>
                                            window.open(
                                                `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                                                    link + "if you're new here sign-up with the referral code : " + referralcode
                                                )}`,
                                                "_blank"
                                            )
                                        }
                                    >
                                        <FaLinkedinIn size={24} />
                                    </Button>
                                    <Button
                                        variant="link"
                                        className="p-2 rounded-circle bg-light mx-1 text-dark"
                                        onClick={() =>
                                            window.open(
                                                `https://api.whatsapp.com/send?text=${encodeURIComponent(
                                                    link + "if you're new here sign-up with the referral code : " + referralcode
                                                )}`,
                                                "_blank"
                                            )
                                        }
                                    >
                                        <FaWhatsapp size={24} />
                                    </Button>
                                    <Button
                                        variant="link"
                                        className="p-2 rounded-circle bg-light mx-1 text-dark"
                                        onClick={handleEmailClick}
                                    // onClick={handleEmailClick}
                                    >
                                        <FaEnvelope size={24} />
                                    </Button>
                                    <Button
                                        variant="link"
                                        className="p-2 rounded-circle bg-light mx-1 text-dark"
                                        onClick={() => setShowSmsBox(true)}
                                    >
                                        <FaSms size={24} />
                                    </Button>
                                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                                        <Button variant="link" className="p-2 rounded-circle bg-light mx-1 text-dark" onClick={() => setShowMemberSelection(true)}>
                                            <FaUsers size={24} />
                                        </Button>
                                    </OverlayTrigger>
                                </div>
                            </div>
                            {/* <div className="mt-3">
                                <Button
                                    variant="dark"
                                    onClick={() => setShowConfirmModal(true)}
                                    disabled={isSubmitting}
                                >
                                    Share with All Topline Members
                                    {isSubmitting && <LinearProgress />}
                                </Button>
                            </div> */}
                        </>

                    ) : (
                        <div>
                            <h4 className="text-center">Select Members to Share With</h4>
                            <ListGroup className="align-items-start">
                                {members.map((member) => (
                                    <ListGroup.Item key={member.pk_user_key}>
                                        <input
                                            type="checkbox"
                                            className="form-check-input rounded-0 border-dark"
                                            checked={selectedMembers.includes(member.pk_user_key)}
                                            onChange={() => handleSelectMember(member.pk_user_key)}
                                        />
                                        <label className="form-check-label">{member.first_name + " " + member.last_name}</label>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                            <div className="mt-3 text-center">
                                <Button variant="outline-dark" onClick={() => setShowMemberSelection(false)}>
                                    Back
                                </Button>
                                <Button variant="dark" onClick={handleSend} className="ms-2" disabled={isSubmitting}>
                                    Send
                                    {isSubmitting && <LinearProgress />}
                                </Button>
                            </div>




                        </div>

                    )}
                </Modal.Body>
            </Modal>
            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Share</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <p>Are you sure you want to share this article with all Topline Members?</p>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button variant="outline-dark" onClick={() => setShowConfirmModal(false)}>
                        No
                    </Button>
                    <Button variant="dark" onClick={handleShareAllTopline} disabled={isSubmitting}>
                        Yes, Share
                        {isSubmitting && <LinearProgress />}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ShareModal;
